import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export enum YesNoCancelModalResult {
  YES, NO, CANCEL
}

export interface YesNoCancelDialogData {
  contentKey: string;
  yesKey?: string;
  noKey?: string;
  cancelKey?: string;
}

@Component({
  selector: 'yes-no-cancel-modal',
  templateUrl: './yes-no-cancel-modal.component.html',
  styleUrls: [
    '../../../../../../assets/styles/components/modal.component.scss'
  ],
  encapsulation: ViewEncapsulation.None
})
export class YesNoCancelModalComponent {

  constructor(protected dialogRef: MatDialogRef<YesNoCancelModalComponent, YesNoCancelModalResult>,
              @Inject(MAT_DIALOG_DATA) public data: YesNoCancelDialogData) {
    data.yesKey = data.yesKey || 'APP.GENERAL.YES';
    data.noKey = data.noKey || 'APP.GENERAL.NO';
    data.cancelKey = data.cancelKey || 'APP.GENERAL.CANCEL';
  }

  yes(): void {
    this.dialogRef.close(YesNoCancelModalResult.YES);
  }

  no(): void {
    this.dialogRef.close(YesNoCancelModalResult.NO);
  }

  cancel(): void {
    this.dialogRef.close(YesNoCancelModalResult.CANCEL);
  }
}
